import { init, jwtDeleteSuccess, jwtSetSuccess } from './jwt.actions';
import { createReducer, on } from '@ngrx/store';
import { JwtTokens } from '@wizbii-utils/angular/jwt';

export const jwtFeatureKey = 'jwtNGRX';

export type NGRXJwtState = JwtTokens | null;
export const initialState: NGRXJwtState = null as NGRXJwtState;

export const jwtReducer = createReducer(
  initialState,
  on(init, (_, { jwtTokens }) => jwtTokens),
  on(jwtSetSuccess, (_, { jwtTokens }) => jwtTokens),
  on(jwtDeleteSuccess, () => null)
);
